
import { defineComponent } from 'vue';
import cloneDeep from 'lodash.clonedeep';
import debounce from 'lodash.debounce';
import PartVehicleItem from './PartVehicleItem.vue';
import {
  getVehicleList,
  getPartPartsList,
  getVehicleDropdownList
} from '@/api/apis';
import SearchIcon from '@/components/icons/SearchIcon.vue';
import Banner from '@/components/banner/Banner.vue';
import { message } from 'ant-design-vue';
import { useRoute } from 'vue-router';

interface PartProps {
  vehicles: any[];
  vehicleDropdownList: any[];
  [key: string]: any;
}

export default defineComponent({
  name: 'Part',
  data(): PartProps {
    return {
      loading: false,
      loaded: false,
      vehicles: [],
      vehicleDropdownList: [],
      pageNo: 1,
      pageSize: 6,
      pageSizeOptions: ['6', '12'],
      current: 1,
      total: 0,
      partNameQueryParam: {
        name: '',
        vehicleId: undefined
      },
      partNoQueryParam: {
        modelNum: ''
      },
      fetching: false,
      lastFetchId: 0,
      fetchVehicle: null,
      isThroughSelect: false
    };
  },
  components: {
    PartVehicleItem,
    SearchIcon,
    Banner
  },
  created() {
    const route = useRoute();
    localStorage.removeItem('diagramPageNo');
    const params = route.params;

    const query = route.query;

    this.loadData();

    this.fetchVehicle = debounce(value => {
      // 判断value 是不是中文
      if (value.trim() && !/\w[a-zA-Z0-9_]*/.test(value.trim())) {
        message.error(this.$t('part.input_right_vin'));
        return;
      }

      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.vehicleDropdownList = [];
      this.fetching = true;
      getVehicleDropdownList({
        vin: value.trim()
      }).then(res => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return;
        }
        this.vehicleDropdownList = res.result || [];
        this.fetching = false;
      });
    }, 500);
  },
  methods: {
    async loadData() {
      this.loading = true;
      const res = await getVehicleList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (res.success) {
        this.total = res.result.total;

        this.vehicles = res.result.records || [];
      }

      const dRes = await getVehicleDropdownList({
        vin: ''
      });

      if (dRes.success) {
        this.vehicleDropdownList = dRes.result || [];
      }

      this.loading = false;

      this.loaded = true;
    },
    handleChecked(vehicle, isCancel) {
      this.vehicleDropdownList = [];
      if (!isCancel) {
        this.vehicleDropdownList.push(vehicle);
        this.partNameQueryParam = {
          ...this.partNameQueryParam,
          vehicleId: vehicle.id
        };
      } else {
        this.partNameQueryParam = {
          ...this.partNameQueryParam,
          vehicleId: undefined
        };
        if (this.isThroughSelect) {
          this.pageNo = 1;
          this.isThroughSelect = false;
          this.loadData();
        }
      }
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    getSearchBtn1Style() {
      const isActive = !!this.partNoQueryParam.modelNum;
      return {
        width: 'auto',
        'background-color': !isActive ? '#E5EAF4' : '#039'
      };
    },
    getSearchBtn2Style() {
      const isActive = !!this.partNameQueryParam.name;
      return {
        width: 'auto',
        'background-color': !isActive ? '#E5EAF4' : '#039'
      };
    },
    onSearchNo() {
      const form = (this.$refs as any).modelForm;

      form
        .validate()
        .then(async () => {
          const res = await getPartPartsList({
            modelNum: this.partNoQueryParam.modelNum
              ? this.partNoQueryParam.modelNum.trim()
              : ''
          });
          if (res.success) {
            const data = res.result || {};

            const hasResult = data.total >= 2;
            const vehicleId = data.records[0].vehicleId;
            if (data.total === 1) {
              window.open(
                `/part-detail/${
                  data.records[0].id
                }/${vehicleId}?modelNum=${this.partNoQueryParam.modelNum.trim()}`
              );
            } else {
              window.open(
                `/part-result?isNo=1&modelNum=${this.partNoQueryParam.modelNum.trim()}&hasResult=${Number(
                  hasResult
                )}`
              );
            }
          }
        })
        .catch();
    },
    onSearchName() {
      const form = (this.$refs as any).numForm;
      form
        .validate()
        .then(async () => {
          const res = await getPartPartsList({
            partName: this.partNameQueryParam.name
              ? this.partNameQueryParam.name.trim()
              : '',
            vehicleId: this.partNameQueryParam.vehicleId
          });

          if (res.success) {
            const data = res.result || {};
            const hasResult = data.total >= 2;
            if (data.total === 1) {
              window.open(
                `/partdetail/${data.records[0].id}?name=${this.partNameQueryParam.name}`
              );
            } else {
              const vehicle: any = this.vehicleDropdownList.find(
                (s: any) => s.id === this.partNameQueryParam.vehicleId
              );

              const modelNum = vehicle ? vehicle.modelNum : '';

              window.open(
                `/part-result?isNo=0&partName=${
                  this.partNameQueryParam.name
                }&vehicleId=${
                  this.partNameQueryParam.vehicleId
                }&hasResult=${Number(hasResult)}&model=${modelNum || ''}`
              );
            }
          }
        })
        .catch();
    },
    async handleVehicleChange() {
      const vehicles = cloneDeep(
        this.vehicleDropdownList.filter(
          (s: any) => s.id === this.partNameQueryParam.vehicleId
        )
      );

      this.isThroughSelect = true;

      if (!this.partNameQueryParam.vehicleId) {
        const form = (this.$refs as any).numForm;

        this.$nextTick(() => {
          form.clearValidate('vehicleId');
        });
      }

      if (vehicles.length > 0) {
        // check the item
        this.$bus.$emit('single-check-part-vehicle', vehicles[0].id);

        this.vehicles = vehicles;

        this.total = 1;

        this.pageNo = 1;
      } else {
        this.$bus.$emit('clear-check-part-vehicle');

        this.pageNo = 1;
        await this.loadData();

        // this.vehicleDropdownList = [];
        this.fetchVehicle('');
      }
    },
    onSearchModelNumChange() {
      if (!this.partNoQueryParam.modelNum) {
        const form = (this.$refs as any).modelForm;

        this.$nextTick(() => {
          form.clearValidate('modelNum');
        });
      }
    },
    onSearchNameChange() {
      if (!this.partNameQueryParam.name) {
        const form = (this.$refs as any).numForm;

        this.$nextTick(() => {
          form.clearValidate('name');
        });
      }
    }
  }
});
